const getAllDocumentsFromCollection = async collectionRef => {
  const response = await collectionRef.get();
  return response.docs.map(doc => doc.data());
};

export default getAllDocumentsFromCollection;
